import { config } from "../../../../enviroment";
import axios from "axios";
import { store } from "../../../../helpers/history";
import {apolloClientService} from '../../../../services/apollo-client';
export const readsService = {
    meterReads,
    getDropdownpData
};

  function meterReads(accountId,saId){
    let APIquery= 
    `query{ 
        getRealTimeMeterReads
        }`;
    let headers={
        saId:saId,
      accountId:accountId,
      tenantCode: config.constants.BASE_TENANT_CODE
      }
      return  apolloClientService.ApolloClientgqlsUsage(APIquery,headers); 
  }

  function getDropdownpData(groupCode,languageCode) {
    let APIquery =
      `{  getDropdownData(input:{groupCode:"` +
      groupCode +
      `",languageCode:"`+languageCode+`"})
     }`;
    return apolloClientService.ApolloClientgqls(APIquery);
} 
